import React, { Component, Fragment } from "react";
import { Table, Button, Row, Col, Card, Icon, Modal, Pagination } from "antd";
import Media from "react-media";
import { Link } from "react-router-dom";
import queryString from "query-string";

import API from "../../Components/API";
import FilterComponent from "../../Components/MissionsComponents/FilterComponent";
import SearchComponent from "../../Components/MissionsComponents/SearchComponent";
import Config from "../../Config/const";
import BreadCrumbComponent from "../../Components/Layout/BreadCrumbComponent";
import {
  extractOrder,
  toTimeString,
  syncFilters,
  tableIndexStyle
} from "../../Components/CommonFunctions";
import actionApi from "../../Components/MissionsComponents/AcquisitionLogic";
import history from "../../history";
import withToast from "../../Components/Hocs/withToast";
import axios from "axios";

let controllerRef;

const convertToBoolean = value => {
  switch (value) {
    case "Yes":
      return "True";
    case "No":
      return "False";
    default:
      return "";
  }
};

const renderIcon = stat => {
  stat = stat === "true" ? 1 : 0;

  const Night = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height="24"
      viewBox="0 0 24 24"
      width="24"
    >
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <g>
          <g>
            <path
              fill="#515ab0"
              d="M11.1,12.08C8.77,7.57,10.6,3.6,11.63,2.01C6.27,2.2,1.98,6.59,1.98,12c0,0.14,0.02,0.28,0.02,0.42 C2.62,12.15,3.29,12,4,12c1.66,0,3.18,0.83,4.1,2.15C9.77,14.63,11,16.17,11,18c0,1.52-0.87,2.83-2.12,3.51 c0.98,0.32,2.03,0.5,3.11,0.5c3.5,0,6.58-1.8,8.37-4.52C18,17.72,13.38,16.52,11.1,12.08z"
            />
          </g>
          <path
            fill="#515ab0"
            d="M7,16l-0.18,0C6.4,14.84,5.3,14,4,14c-1.66,0-3,1.34-3,3s1.34,3,3,3c0.62,0,2.49,0,3,0c1.1,0,2-0.9,2-2 C9,16.9,8.1,16,7,16z"
          />
        </g>
      </g>
    </svg>
  );

  const Day = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="#ffb854"
        d="M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
      />
    </svg>
  );

  const icon = stat ? "check-circle" : "close-circle";
  const iconColor = stat ? "#52c41a" : "#F63A49";
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      {stat ? <Icon component={Day} /> : <Icon component={Night} />}
    </div>
  );
};

const redirectLink = (url, id) => {
  return `${url}${id}`;
};

const columns = [
  {
    title: <span className="table-index-number">NO</span>,
    dataIndex: "index",
    align: "center",
    render(text) {
      return tableIndexStyle(text);
    }
  },
  {
    title: "ID",
    dataIndex: "id",
    render: id => (
      <Link
        to={redirectLink("/missions_management/download_missions/view/", id)}
      >
        {id}
      </Link>
    )
  },
  {
    title: "NAME",
    dataIndex: "name",
    sorter: true
  },
  {
    title: "COMMAND EXECUTION TIME",
    dataIndex: "execution_time",
    sorter: true,
    hideOnMedium: true
  },
  {
    title: "SATELLITE",
    dataIndex: "satellite",
    sorter: true
  },
  {
    title: "AOS TIME",
    dataIndex: "aos_time",
    sorter: true,
    hideOnMedium: true
  },
  {
    title: "DAY DOWNLOAD",
    dataIndex: "day_download",
    sorter: true,
    render: stat => renderIcon(stat)
  },
  {
    title: "RECEIVING STATION",
    dataIndex: "receiving_station",
    sorter: true,
    hideOnSmall: true
  },
  {
    title: "STATUS",
    dataIndex: "status",
    sorter: true
  },
  {
    title: "COMMAND",
    dataIndex: "command",
    sorter: true,
    render: (text, data) => {
      if (text === "N/A") {
        return "N/A";
      }
      return (
        <Link
          to={redirectLink(
            "/missions_management/commands/view/",
            data.commandId
          )}
          target="_blank"
        >
          {text} <Icon type="edit" />
        </Link>
      );
    }
  }
];

const getResponsiveColumns = matches => {
  if (matches.medium) {
    return columns.filter(column => !column.hideOnMedium);
  }
  if (matches.small) {
    return columns.filter(
      column => !column.hideOnMedium && !column.hideOnSmall
    );
  }
  return columns;
};

let query = {};

class DownloadMissionsPage extends Component {
  constructor(props) {
    super(props);
    query = queryString.parse(window.location.search);

    this.state = {
      satellite: query.satellite || "",
      selectedRowKeys: [],
      pagination: {},
      dayDownload: query.dayDownload || "",
      station: "",
      status: query.status || "",
      loading: false,
      downloadMissions: "",
      keyword: "",
      visible: false,
      currentPage: 1,
      pageSize: 25
    };
  }

  componentDidMount() {
    this.fetch();
  }

  fetch = (page = 1, sort = "-id") => {
    const dayDownload = convertToBoolean(this.state.dayDownload);
    this.setState({ loading: true });
    if (controllerRef) {
      controllerRef.cancel();
    }
    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();
    controllerRef = source;

    API.get(
      `missions_management/download_missions?format=json&satellite=${this.state.satellite}&status=${this.state.status}&ordering=${sort}&search=${this.state.keyword}&page=${this.state.currentPage}&page_size=${this.state.pageSize}&day_download=${dayDownload}`, { cancelToken: source.token }
    )
      .then(res => {
        const getTotalPages = parseInt(res ? res.data.pagination.count : 0);
        this.setState({
          loading: false,
          downloadMissions: res.data,
          total: getTotalPages
        });
        controllerRef = null;
      })
      .catch(function(error) {
        if (error.toString() !== "Cancel") {
          console.log(error);
        }
      });
  };

  processAction = () => {
    this.setState({
      loading: true
    });
    const call = actionApi(
      this.state.action,
      this.state.selectedRowKeys,
      "missions_management/download_missions"
    );
    call
      .then(e => {
        this.fetch();
        this.setState({
          selectedRowKeys: []
        });
        this.props.openNotification(
          "success",
          "Success!",
          "Request successful!"
        );
      })
      .catch(err => {
        console.log(err);
        this.setState({
          loading: false,
          selectedRowKeys: []
        });
        this.props.openNotification("error", "Oops!", "Something went wrong!");
      });
  };

  formatMissions = tableData => {
    const missions = [];
    const rawData = tableData ? tableData.data : [];
    rawData.map((val, index) => {
      missions.push({
        index: `${this.state.pageSize * (this.state.currentPage - 1) +
          1 +
          index}`,
        key: `${val.id}`,
        id: `${val.id}`,
        name: `${val.name}`,
        execution_time: `${
          val.command ? toTimeString(val.command.execution_time) : "N/A"
        }`,
        satellite: `${val.satellite}`,
        aos_time: `${toTimeString(val.aos_time)}`,
        day_download: `${val.day_download}`,
        receiving_station: `${val.receiving_station}`,
        status: `${val.status}`,
        command: `${val.command ? val.command.section_number : "N/A"}`,
        commandId: `${val.command ? val.command.id : "N/A"}`
      });
    });
    return missions;
  };

  handleActionChange = () => {
    if (this.state.action === "Delete") {
      this.setState({
        loading: true,
        visible: true
      });
    } else {
      this.processAction();
    }
  };

  deleteRows = () => {
    this.setState({ visible: false });
    this.processAction();
  };

  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager
    });
    this.fetch(pagination.current, extractOrder(sorter));
  };

  handleFilterChange = (filter, data) => {
    query = queryString.parse(window.location.search);
    syncFilters(query, filter, data);

    switch (filter) {
      case "status":
        this.setState(
          {
            status: data,
            currentPage: 1
          },
          () => {
            this.fetch();
          }
        );
        break;
      case "dayDownload":
        this.setState(
          {
            dayDownload: data,
            currentPage: 1
          },
          () => {
            this.fetch();
          }
        );
        break;
      case "satellite":
        this.setState(
          {
            satellite: data,
            currentPage: 1
          },
          () => {
            this.fetch();
          }
        );
        break;
      default:
        return false;
    }
  };

  onSelectChange = selectedRowKeys => {
    this.setState({ selectedRowKeys });
  };

  enterPressed = event => {
    const keyCode = window.event ? event.which : event.keyCode;
    if (keyCode === 13) {
      this.setState(
        {
          currentPage: 1
        },
        () => {
          this.fetch();
        }
      );
    }
  };

  onPaginationChange = (page = 1, size) => {
    if (page !== this.state.currentPage && page > 0) {
      this.onPageChange(page);
    }

    if (size !== this.state.pageSize) {
      this.onPageSizeChange(size);
    }
  };

  onPageChange(page) {
    this.setState(
      {
        currentPage: page
      },
      () => {
        this.fetch();
      }
    );
  }

  onPageSizeChange(size) {
    this.setState(
      {
        pageSize: size,
        currentPage: 1
      },
      () => {
        this.fetch();
      }
    );
  }

  render() {
    const urls = {
      "/": "MISSIONS",
      "/missions_management/download_missions": "DOWNLOAD MISSIONS"
    };
    const { selectedRowKeys, uploadMissions } = this.state;
    const a = uploadMissions ? uploadMissions.pagination.count : [];
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      hideDefaultSelections: true,
      selections: [
        {
          key: "all-data",
          text: "Select All Data",
          onSelect: () => {
            this.setState({
              selectedRowKeys: [...Array(a).keys()]
            });
          }
        },
        {
          key: "odd",
          text: "Select Odd Row",
          onSelect: changableRowKeys => {
            let newSelectedRowKeys = [];
            newSelectedRowKeys = changableRowKeys.filter((key, index) => {
              if (index % 2 !== 0) {
                return false;
              }
              return true;
            });
            this.setState({ selectedRowKeys: newSelectedRowKeys });
          }
        },
        {
          key: "even",
          text: "Select Even Row",
          onSelect: changableRowKeys => {
            let newSelectedRowKeys = [];
            newSelectedRowKeys = changableRowKeys.filter((key, index) => {
              if (index % 2 !== 0) {
                return true;
              }
              return false;
            });
            this.setState({ selectedRowKeys: newSelectedRowKeys });
          }
        }
      ]
    };
    const hasSelected = selectedRowKeys.length > 0;
    const computeSize = (size, count) => {
      if (count < size) {
        return count;
      }
      return size;
    };
    return (
      <Fragment>
        <BreadCrumbComponent data={urls} titlePage="Download Missions" />
        <Row>
          <Col>
            <Card
              title="Filters"
              extra={
                <Button
                  type="primary"
                  onClick={() =>
                    history.push("/missions_management/download_missions/add")
                  }
                >
                  Add Download Mission <Icon type="plus-circle" />
                </Button>
              }
            >
              <Row gutter={{ md: 24 }}>
                <Col md={6} xs={24}>
                  <span className="label">By Status</span>
                  <FilterComponent
                    value={this.state.status}
                    optionData={Config.mission.acquisition.filterStats}
                    placeholder="Choose a status"
                    handleChange={e => {
                      this.handleFilterChange("status", e);
                    }}
                  />
                </Col>
                <Col md={6} xs={24}>
                  <span className="label">By day download</span>
                  <FilterComponent
                    value={this.state.dayDownload}
                    optionData={Config.mission.acquisition.dayDownload}
                    placeholder="Day Download"
                    handleChange={e => {
                      this.handleFilterChange("dayDownload", e);
                    }}
                  />
                </Col>
                <Col md={6} xs={24}>
                  <span className="label">By Satellite</span>
                  <FilterComponent
                    value={this.state.satellite}
                    optionData={Config.mission.acquisition.filterSatellite}
                    placeholder="Choose a Satellite"
                    handleChange={e => {
                      this.handleFilterChange("satellite", e);
                    }}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col md={24}>
            <Card style={{ marginTop: "20px" }}>
              <Row>
                <Col md={12}>
                  <div className="actionGroup">
                    <span className="label">Action:</span>
                    <div style={{ width: "300px", margin: "0 15px" }}>
                      <FilterComponent
                        optionData={
                          Config.mission.acquisition.selectedActionAcquisition
                        }
                        placeholder="Choose an action"
                        handleChange={e => {
                          this.setState({ action: e });
                        }}
                      />
                    </div>
                    <Button
                      type="primary"
                      onClick={() => {
                        this.handleActionChange();
                      }}
                      disabled={!hasSelected}
                      loading={this.state.loading}
                    >
                      Go
                    </Button>
                    <span style={{ marginLeft: 8 }}>
                      {hasSelected
                        ? `Selected ${selectedRowKeys.length} items out of ${this.state.downloadMissions.pagination.count}`
                        : ""}
                    </span>
                  </div>
                </Col>
                <Col md={12}>
                  <Row>
                    <Col md={14}>
                      <div
                        style={{
                          float: "right",
                          paddingTop: "22px"
                        }}
                      >
                        {this.state.downloadMissions
                          ? `${computeSize(
                              this.state.pageSize *
                                (this.state.currentPage - 1) +
                                1,
                              this.state.downloadMissions.pagination.count
                            )} - ${computeSize(
                              this.state.pageSize * this.state.currentPage,
                              this.state.downloadMissions.pagination.count
                            )} of ${
                              this.state.downloadMissions.pagination.count
                            } items`
                          : ""}
                      </div>
                    </Col>
                    <Col md={10}>
                      <div
                        style={{
                          width: "95%",
                          float: "right",
                          paddingTop: "16px"
                        }}
                      >
                        <SearchComponent
                          name="search"
                          onkeypress={e => {
                            this.enterPressed(e);
                          }}
                          onchange={e => {
                            this.setState({
                              keyword: e.target.value
                            });
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Media
                queries={{
                  xs: "(max-width: 1099px)",
                  small: "(min-width: 1100px) and (max-width: 1199px)",
                  medium: "(min-width: 1200px) and (max-width: 1399px)",
                  large: "(min-width: 1400px)"
                }}
              >
                {matches => (
                  <Fragment>
                    <Table
                      scroll={matches.xs ? { x: "max-content" } : {}}
                      size="middle"
                      rowSelection={rowSelection}
                      columns={getResponsiveColumns(matches)}
                      loading={this.state.loading}
                      dataSource={this.formatMissions(
                        this.state.downloadMissions
                      )}
                      pagination={false}
                      onChange={this.handleTableChange}
                      bordered
                    />
                  </Fragment>
                )}
              </Media>
              <Pagination
                style={{ marginTop: "20px", float: "right" }}
                showSizeChanger
                onChange={this.onPaginationChange}
                onShowSizeChange={this.onPaginationChange}
                current={this.state.currentPage}
                total={this.state.total}
                pageSizeOptions={["25", "50", "100"]}
                pageSize={this.state.pageSize}
              />
            </Card>
          </Col>
          <Modal
            visible={this.state.visible}
            onOk={this.deleteRows}
            onCancel={() => {
              this.setState({ visible: false, loading: false });
            }}
          >
            <h3 style={{ margin: "20px" }}>
              <Icon
                type="question-circle"
                className="modal_icon"
                style={{ color: "orange" }}
              />
              Are you sure you want to delete?
            </h3>
          </Modal>
        </Row>
      </Fragment>
    );
  }
}

export default withToast(DownloadMissionsPage);
